import React from 'react'
import { LazyLoad } from '../../common/Functions'

function Ecosystem() {
  return (
  <section className="max-w-screen-xl	mx-auto text-center">
    <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            About the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            Drapshop is a freelance project I used to work with during the Pandemic. The agency that I have worked with provided a functional scope document with the defined features, whereas I followed the process flow and the design objective. The system facilitates its users to find restaurants or grocery shops around their area, pick from the list of their online menu, and get delivered fresh items straight to their door. There are four different types of registered users - customers, restaurants/grocery store owners, drivers, and administrators. I worked on the customer web and mobile app, restaurant or grocery web and mobile app, and driver mobile app.
          </p>
        </div>
        <div className="content px-20 pb-20">
          <p className="text-left font-bold text-2xl">
            My Role in the Project
          </p>
          <p className="text-left text-lg text-gray-600">
            I was a freelance UI/UX Designer for this project. My goal is to provide a user-friendly and appealing interface for its users. I designed the UI components of web mockups then shared with the client an Adobe XD link where they can use it for their front-end development.
          </p>
        </div>
        <em className="text-gray-400 mb-10">Drapshop Restaurant or Grocery Store Web App Mock-ups</em>
        <LazyLoad src={require('../../common/images/drapshop/web-mockup.png')} alt="Drapshop Web Mockup"/>
        <em className="text-gray-400 py-10">Drapshop Customer Mobile App Mock-ups</em>
        <LazyLoad src={require('../../common/images/drapshop/mobile-mockup.png')} alt="Drapshop Mobile Mockup"/>
      </div>
    </div>
  </section>
  )
}

export default Ecosystem
